import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Circle = ({
  height = 24,
  color = colors.grey15,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={height} viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="12" r="10.5" strokeWidth="3" stroke={getColor(color, isColorInherited)} />
  </SvgIcon>
);
